




































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import FileUpload from '@/components/FileUpload/index.vue'
import {
  getDesktopVersionDetail,
  saveTutuDesktopVersion
} from '@/api/production/production'

@Component({
  name: 'ProductionPCEdit',
  components: {
    FileUpload
  }
})
export default class extends mixins(DisplayMixin) {
  params:any = {
    type: '',
    size: 0,
    id: '',
    version: '',
    path: '',
    version_code: '',
    status: '',
    newfunction: ''
  }

  created() {
    this.getPageDetail()
  }

  async getPageDetail() {
    let res: any = await getDesktopVersionDetail(this.$route.query)
    this.params = res.data
  }

  async handeSubmit() {
    for (let key in this.params) {
      if (typeof this.params[key] === 'string') {
        this.params[key] = this.params[key].trim()
      }
    }
    if (this.params.size <= 0) return this.$message.warning('请输入安装包体积')
    if (!this.params.version) return this.$message.warning('请输入版本号')
    if (!this.params.path) return this.$message.warning('请填写下载地址')
    if (!this.params.status) return this.$message.warning('请选择发布状态')
    if (!this.params.newfunction) return this.$message.warning('请输入更新内容')
    let res:any = await saveTutuDesktopVersion(this.params)
    if (~~res.status.code === 0) {
      this.$router.go(-1)
    }
  }
}
